import { DEFAULT_ORG_CHART_VIEW_MODE } from '../../domains/orgchart/models/defaults';
import {
  resolveOrgShapeDefaultDimensions,
  type OrgPersonCardViewMode,
} from '../../domains/orgchart/models/orgChartShapeVariants';

export type ShapePickerDimensions = { width: number; height: number };

const isOrgCategory = (category: string): boolean =>
  category === 'orgchart' || category === 'org';

export function resolveShapePickerOrgViewMode(settingsJson: unknown): OrgPersonCardViewMode {
  if (typeof settingsJson !== 'string') return DEFAULT_ORG_CHART_VIEW_MODE;

  try {
    const parsed = JSON.parse(settingsJson) as { orgchart?: { viewMode?: unknown } };
    const viewMode = parsed.orgchart?.viewMode;
    return viewMode === 'compact' || viewMode === 'full'
      ? viewMode
      : DEFAULT_ORG_CHART_VIEW_MODE;
  } catch {
    return DEFAULT_ORG_CHART_VIEW_MODE;
  }
}

export function resolveShapePickerManifestDimensions(input: {
  category: string;
  shapeId: string;
  manifestDimensions?: ShapePickerDimensions;
  orgViewMode: OrgPersonCardViewMode;
}): ShapePickerDimensions | null {
  if (isOrgCategory(input.category)) {
    const orgDimensions = resolveOrgShapeDefaultDimensions(input.shapeId, input.orgViewMode);
    if (orgDimensions) return orgDimensions;
  }

  return input.manifestDimensions ?? null;
}
